import { COLORS, SIZE, STRINGS } from '@tm/shared'

function hex(n) {
  return '#' + n.toString(16).padStart(6, '0')
}

const FONT_FAMILY = '"Quicksand","Nunito",system-ui,sans-serif'

export function createModeToggle({ active = 'build', onChange }) {
  const group = document.createElement('div')
  group.setAttribute('role', 'tablist')
  group.setAttribute('aria-label', 'Mode Studio')
  group.style.cssText = [
    'display:inline-flex',
    `border:2px solid ${hex(COLORS.ink)}`,
    'border-radius:14px',
    'overflow:hidden',
    `background:${hex(COLORS.paper)}`,
  ].join(';')

  const modes = [
    { id: 'build', label: STRINGS.modeBuild, icon: '🧩' },
    { id: 'play', label: STRINGS.modePlay, icon: '▶️' },
    { id: 'share', label: STRINGS.modeShare, icon: '🔗' },
  ]

  modes.forEach((m) => {
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.setAttribute('role', 'tab')
    btn.setAttribute('aria-selected', String(m.id === active))
    btn.dataset.mode = m.id
    btn.innerHTML = `<span aria-hidden="true">${m.icon}</span> <span>${m.label}</span>`
    btn.style.cssText = [
      `min-height:${SIZE.minTapTargetDp}px`,
      'padding:8px 16px',
      'border:none',
      'cursor:pointer',
      'font-size:18px',
      'font-weight:bold',
      `font-family:${FONT_FAMILY}`,
      `background:${m.id === active ? hex(COLORS.primary) : 'transparent'}`,
      `color:${m.id === active ? hex(COLORS.paper) : hex(COLORS.ink)}`,
      'touch-action:manipulation',
      'user-select:none',
      '-webkit-tap-highlight-color:transparent',
    ].join(';')
    btn.addEventListener('click', () => {
      if (typeof onChange === 'function') onChange(m.id)
    })
    group.appendChild(btn)
  })

  return group
}
